<template>
    <router-view
      :key="id"
      :get-item="cachedGetItem"
      :set-item="setItem"
      :set-cache="setCache"
      :get-results="cachedGetResults"
    />
</template>

<script>
import { memoize } from 'lodash'

import { http } from '@/services/http.js'

export default {
  name: 'CollectionsDetailPage',
  props: {
    id: String,
  },
  watch: {
    id() {
      this.cachedGetItem.cache.clear()
      this.cachedGetResults.cache.clear()
    },
  },
  created() {
    this.cachedGetItem = memoize(this.getItem)
    this.cachedGetResults = memoize(this.getResults, i => JSON.stringify(i))
  },
  methods: {
    getItem() {
      return http.get(`/api/collections/${this.id}/`)
        .then(response => {
          const name = response.data.name
          if (name) {
            document.title = `${name} - Great American Art`
          }
          return response.data
        })
    },
    setItem(item) {
      return http.put(`/api/collections/${this.id}/`, item)
        .then(response => {
          // update the local cache
          this.setCache(response.data)
          // update the global cache
          this.$store.dispatch('cache/patch', {type: 'collections', items: [response.data]})
          // return the updated item
          return response.data
        })
        .catch(err => {
          // Custom message for "mid-air collision" error
          if (err.response?.data?.modified) {
            err.response.data.non_field_errors = ['This collection has been modified by another user. Please reload the page and try again.', ...(err.response.data.non_field_errors || [])]
            delete err.response.data.modified
          }
          throw err
        })
    },
    setCache(item) {
      this.cachedGetItem.cache.set(undefined, Promise.resolve(item))
      this.cachedGetResults.cache.clear()
    },
    getResults(config) {
      return http.get(`/content/search/v3/`, {
        ...config,
        params: {
          artcollection: this.id,
          ...config?.params,
        },
      })
        .then(response => {
          return response.data
        })
    },
  },
}
</script>
